import type { GlobalState } from "../../types/stateTypes";
import { bundleHasMeet } from "./buildExportBundle";

/** True when loading a WRPF tournament would replace another meet already in OpenLifter. */
export function shouldConfirmTournamentSwitch(state: GlobalState, incomingTournamentId: string): boolean {
  if (!bundleHasMeet(state)) return false;
  return state.wrpfSession.tournamentId !== incomingTournamentId;
}
